<template>
  <div class="innerBox">
    <div class="row">
      <div class="col-md-8">
        <h2 class="mb-4">Informasi Perusahaan</h2>
      </div>
      <div class="col-md-4 text-right pr-5">
        <button type="button" class="btn btn-primary" @click="editCompanyConfirmation">Sunting</button>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-6 padding-20px">
        <div class="image-container" @mouseover="mouseOnImage=true" @mouseleave="mouseOnImage=false">
          <div class="image-content">
            <div style="padding:20px">
              <img :src="env.baseImage + '/' + data.logo" style="width: 100%; max-height: 100%;">
              <!-- <img src="/img/company_logo.012377ff.png" style="width: 100%; max-height: 100%;"> -->
            </div>
          </div>
          <div
            class="image-content clickAble"
            :class="mouseOnImage ? 'fade-in' : 'fade-out'"
            style="z-index:10; border-radius: 15px; background-color: #0000008d;"
            @click="modal.uploadImage = true"
          >
            <i class="fas fa-camera fa-10x" style="color: #212121;"></i>
            <h2 class="mt-3">Ubah Gambar</h2>
          </div>
        </div>
      </div>
      <div class="col-md-6 padding-20px">
        <table class="table company-detail-table">
          <tr v-for="field in detailFields">
            <th>{{ field.title }}</th>
            <th style="padding-left:15px; padding-right: 15px;">:</th>
            <td>{{ data[field.variable] ? data[field.variable] : '-' }}</td>
          </tr>
          <tr>
            <th>Logo Untuk Mencetak</th>
            <th style="padding-left:15px; padding-right: 15px;">:</th>
            <td>
              <div class="image-container" @mouseover="mouseOnImage2=true" @mouseleave="mouseOnImage2=false" style="padding-top: 60%;">
                <div class="image-content">
                  <div style="padding:20px">
                    <img :src="env.baseImage + '/' + data.logo_alternate" style="width: 100%; max-height: 100%;">
                    <!-- <img src="/img/company_logo.012377ff.png" style="width: 100%; max-height: 100%;"> -->
                  </div>
                </div>
                <div
                  class="image-content clickAble"
                  :class="mouseOnImage2 ? 'fade-in' : 'fade-out'"
                  style="z-index:10; border-radius: 15px; background-color: #0000008d;"
                  @click="modal.uploadImage2 = true"
                >
                  <i class="fas fa-camera fa-4x" style="color: #212121;"></i>
                  <h4 class="mt-2">Ubah Gambar</h4>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <h3>Akun Bank</h3>

    <div class="row bank-accounts">
      <div class="col-md-12">
        <table class="table">
          <thead>
            <tr>
              <th>Nama Akun</th>
              <th>Nama Bank</th>
              <th>Nomor Bank</th>
              <th><i class="fas fa-cog"></i></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="bank_account.length > 0">
              <tr v-for="bank in bank_account">
                <td>{{ bank.bank_account_name }}</td>
                <td>{{ bank.bank_name }}</td>
                <td>{{ bank.bank_account }}</td>
                <td>
                  <button class="btn btn-outline-danger" title="Hapus" @click="deleteBankAccount(bank.id)">
                    <i class="fas fa-times"></i>
                  </button>
                </td>
              </tr>
            </template>

            <!-- Add New Bank Account Start -->
            <tr>
              <td><input type="text" class="form-control" placeholder="Nama Akun" v-model="new_bank_account.bank_account_name"></td>
              <td><input type="text" class="form-control" placeholder="Nama Bank" v-model="new_bank_account.bank_name"></td>
              <td><input type="text" class="form-control" placeholder="Nomor Bank" v-model="new_bank_account.bank_account"></td>
              <td>
                <button class="btn btn-outline-success" title="Tambah Baru" @click="newBankAccount">
                  <i class="fas fa-plus"></i>
                </button>
              </td>
            </tr>
            <!-- Add New Bank Account End -->

          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Starts -->
    <edit-company-detail
      v-if="modal.edit"
      :data="data"
      @updateDetail="getCompanyDetail"
      @closeModal="modal.edit = false"
    ></edit-company-detail>

    <upload-image
      v-if="modal.uploadImage"
      title="Ubah Logo Perusahaan"
      endpoint="/api/v1/workorder/steps/upload"
      @onResponse="editLogoConfirmation"
      @closeModal="modal.uploadImage = false"
    ></upload-image>

    <upload-image
      v-if="modal.uploadImage2"
      title="Ubah Logo Untuk Mencetak"
      endpoint="/api/v1/workorder/steps/upload"
      @onResponse="editPrintLogoConfirmation"
      @closeModal="modal.uploadImage2 = false"
    ></upload-image>
    <!-- Modal Ends -->

  </div>
</template>

<script>
  import uploadImage from '@/components/modal/uploadImage'

  import editCompanyDetail from './children/editCompanyDetail'
  import env from '@/env'

  export default {
    data () {
      return {
        env,
        modal : {
          edit : false,
          uploadImage : false,
          uploadImage2 : false,
        },
        mouseOnImage : false,
        mouseOnImage2 : false,
        detailFields : [],
        data : {
          id: 0,
          name : '',
          fullname : '',
          address : '',
          phone_number : '',
          fax_number : '',
          email : '',
          website : '',
          logo : '',
          logo_alternate : '',
          // bank_account_name : '',
          // bank_account : '',
          // bank_name : '',
          ketik_saran_number: '',
        },
        raw_data : null,

        bank_account : [],
        new_bank_account : {
          // company_profile_id: 1,
          bank_account_name : '',
          bank_name : '',
          bank_account : ''
        },
      }
    },
    components : {
      editCompanyDetail,
      uploadImage
    },
    mounted () {
      this.generateFields();
      this.getCompanyDetail();
    },
    methods : {
      generateFields(){
        this.addDetailField("Nama Perusahaan", "name")
        this.addDetailField("Nama Lengkap Perusahaan", "fullname")
        this.addDetailField("Alamat Perusahaan", "address")
        this.addDetailField("Nomor Telefon", "phone_number")
        this.addDetailField("Nomor Fax", "fax_number")
        this.addDetailField("Ketik dan Saran", "ketik_saran_number")
        this.addDetailField("Email", "email")
        this.addDetailField("Website", "website")
        // this.addDetailField("Bank Name", "bank_name")
        // this.addDetailField("Bank Account", "bank_account")
        // this.addDetailField("Bank Account Name", "bank_account_name")
      },
      addDetailField(title, variable){
        this.detailFields.push({title:title, variable:variable})
      },
      getCompanyDetail(){
        this.$http.get('/api/v1/company_profile')
        .then((resp)=>{
          this.raw_data = resp.data.data;

          this.bank_account = resp.data.data.bank_account;

          //Reset company profile StoreX data (for edit purposes)
          this.$store.dispatch(`setCompanyProfile`, resp.data.data)
        })
        .then(()=>{
          var keys = Object.keys(this.data)
          for(var i in keys) this.data[keys[i]] = this.raw_data[keys[i]] ? this.raw_data[keys[i]] : ''
        })
        .catch((err)=>{console.log(err);})
      },
      editCompanyConfirmation(){
        this.$swal.fire({
          title: 'Apakah anda yakin?',
          text: "Anda akan mengubah seluruh informasi perusahaan, termasuk semua dokumen yang dapat di cetak!",
          type: 'warning',
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.modal.edit = true
          }
        })
      },
      editLogoConfirmation(image){
        this.modal.uploadImage = false;
        this.$swal.fire({
          title: 'Apakah anda yakin?',
          text: "Anda akan mengubah logo untuk perusahaan!",
          type: 'warning',
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.data.logo = image;
            this.$http.put('/api/v1/company_profile', this.data)
            .then((resp)=>{
              this.$store.dispatch('triggerAlert', [true, [`Logo berhasil diubah`]]);
              this.getCompanyDetail();
            })
            .catch((err)=>{
              console.log(err);
              this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
            })
          }
        })
      },
      editPrintLogoConfirmation(image){
        this.modal.uploadImage = false;
        this.$swal.fire({
          title: 'Apakah anda yakin?',
          text: "Anda akan mengubah logo semua dokumen yang dapat di cetak!",
          type: 'warning',
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.data.logo_alternate = image;
            this.$http.put('/api/v1/company_profile', this.data)
            .then((resp)=>{
              this.$store.dispatch('triggerAlert', [true, [`Logo berhasil diubah`]]);
              this.getCompanyDetail();
            })
            .catch((err)=>{
              console.log(err);
              this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
            })
          }
        })
      },
      newBankAccount () {
        let request_payload = JSON.parse(JSON.stringify(this.new_bank_account))
        request_payload.company_profile_id = this.data.id;

        this.$http.post(`/api/v1/company_profile/bank_account`, request_payload)
        .then((resp)=>{
          this.$store.dispatch('triggerAlert', [true, [`Bank ${this.new_bank_account.bank_account_name} telah berhasil ditambahkan`]])
          
          this.getCompanyDetail();

          //Reset new bank account fields, ready for another one
          this.new_bank_account.bank_account_name = ''
          this.new_bank_account.bank_name = ''
          this.new_bank_account.bank_account = ''
        })
        .catch((err)=>{
          console.log(err)
          this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
        })
      },
      deleteBankAccount (id) {
        this.$swal.fire({
          title: 'Apakah anda yakin?',
          text: "Anda akan menghapus bank ini!",
          type: 'warning',
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.$http.delete(`/api/v1/company_profile/bank_account/${id}`)
            .then((resp)=>{
              this.$store.dispatch('triggerAlert', [true, [`Akun bank telah berhasil di-hapus`]]);
              this.getCompanyDetail();
            })
            .catch((err)=>{
              console.log(err);
              this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
            })
          }
        })
      },
    }
  }
</script>

<style scoped>
  .padding-20px{
    padding:20px;
  }
  .clickAble:hover{
    cursor: pointer;
  }
  
  .image-container {
    position:relative;
    width: 100%;
    padding-top: 80%;

    border:2px solid #E0E0E0;
    border-radius: 15px;
  }
  .image-content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .fade-in{
    animation: fadein 0.5s;
  }
  .fade-out{
    opacity: 0;
    animation: fadeout 1s;
  }
  @keyframes fadein {from {opacity: 0;}to {opacity: 1;}}
  @keyframes fadeout {from {opacity: 1;}to {opacity: 0;}}

  .company-detail-table th, .company-detail-table td{
    font-size: 16px;
    padding:10px 0;
    border:0
  }

  .bank-accounts table tr th, .bank-accounts table tr td {
    text-align: center;
  }
</style>